import React from 'react';
import {formatDate} from 'utils/datetime';

import strike from './assets/strike.svg';

const AllocationHeader = ({header, room}) => (
  <div className="allocationHeader">
    <div className="header">{header}</div>
    <div className="room"> {room}</div>
  </div>
);

const Period = ({header, start, end}: any) => (
  <div className="Period">
    {header && <div className="header">{header}</div>}
    <div className="date">
      {formatDate(start)} - {formatDate(end)}
    </div>
  </div>
);

import './styles.css';

const AllocationToUpdate = ({allocation, header}) => (
  <div className="AllocationToUpdate">
    <AllocationHeader header={header} room={allocation.original.room} />
    <div className="PeriodSection">
      <Period
        header="Old"
        start={allocation.original.startDate}
        end={allocation.original.endDate}
      />
      <img src={strike} alt="strike" />
      <Period
        header="New"
        start={allocation.updated.startDate}
        end={allocation.updated.endDate}
      />
    </div>
  </div>
);

export default AllocationToUpdate;
